// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_RAJ","top":"styles_top__3ecPs","left":"styles_left__3h8U6","description":"styles_description__2OGjO"};